import './styles/ShibUserItem.scss';

import { Grid } from '@mui/material';
import { ShibUser } from '@thro-types/users';

import { studentSemesterParser } from 'app/containers/AWPM-FWPM/helper';

interface Props {
  user: ShibUser;
}

export function TestUserItem({ user }: Props) {
  return (
    <Grid container className="shib-user">
      <Grid container>
        <Grid item xs={1} className="shib-user__id">
          {user.id}
        </Grid>
        <Grid item xs={3} className="shib-user__uid">
          {user.email}
        </Grid>
        <Grid item xs={1} className="shib-user__email">
          {user.degree && user.semester ? studentSemesterParser(user.degree, user.semester) : '-'}
        </Grid>
        <Grid item xs={7} className="shib-user__entitlements">
          {user.entitlements.join(', ')}
        </Grid>
      </Grid>
    </Grid>
  );
}
